export function formatDate(value: string): string {
    const localizedDate = value.match(/^(\d{1,2})[./-](\d{1,2})[./-](\d{4})(.*)$/);
    if (localizedDate) {
        const [, day, month, year, suffix] = localizedDate;
        return `${day.padStart(2, '0')}.${month.padStart(2, '0')}.${year}${suffix}`;
    }

    const isoDate = value.match(/^(\d{4})-(\d{1,2})-(\d{1,2})(.*)$/);
    if (isoDate) {
        const [, year, month, day, suffix] = isoDate;
        return `${day.padStart(2, '0')}.${month.padStart(2, '0')}.${year}${suffix}`;
    }

    return value;
}
